import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Estimate } from '../../../../../../shared/models/vendor-order.model';

@Component({
  selector: 'app-expired-quotes-accordion',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './expired-quotes-accordion.component.html',
  styleUrl: './expired-quotes-accordion.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpiredQuotesAccordionComponent {
  readonly estimates = input.required<Estimate[]>();
  readonly orderDeadline = input<string>();

  readonly expiredCount = computed(() => this.estimates().length);
}
